import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import Header from '../body_root/Home_header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './search.css';
import { Toast } from '../components_root/ToastContext';
import { MdLocationCity } from "react-icons/md";
export const seo = {
    title: "Search Tools | aooz Free & Premium Online Utilities for Productivity & SEO",
    description: "Explore aooz Search to quickly find free and premium online tools. Access file converters, SEO analyzers, word counters, favicon generators, and productivity utilities in one place.",
    keywords: "aooz search, online search tools, find tools, productivity search, free seo tools, file converters, text utilities, image to pdf, favicon generator, word counter, premium tools",
    url: "https://aooz.in/search",
    image: "https://aooz.in/assets/logo.png"
};
export default function Search_root() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    return (
        <div>
          
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Products</h2>
                    <div className='post-container'>
 
                    </div>

                </div>
                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Free Services</h2>
                    <div className='post-container'>

                        <div className='ui-grid-100'>
                            <div className=" ui-items items-back p-3 text-h2 bold border cursor rounded-md center" onClick={() => navigate('/image-to-pdf')} >Image to  pdf</div>
                            <div className=" ui-items items-back p-3 text-h2 bold border cursor rounded-md center" onClick={() => navigate('/favicon-generator')} > Favicon Generator </div>
                            <div className=" ui-items items-back p-3 text-h2 bold border cursor rounded-md center" onClick={() => navigate('/word-counter')} >Word counter</div>
                            <div className=" ui-items items-back p-3 text-h2 bold border cursor rounded-md center" onClick={() => navigate('/typing-master')} >Typing master</div>
                        </div>
                    </div>

                </div>
            </div>

           
            
        </div>
    );
}
